<template>
    <div v-if="serie">
        <serie-banner :serie="serie" class="relative">
            <characters-slider :series="series"></characters-slider>
        </serie-banner>

        <episodes-section
            :key="`serie-${serie.id}-episodes-slider`"
            :title="$config('EPISODIOS')"
            :episodes="serie.episodes"
            background-image="https://assets.pinguinitos.com/storage/30k7idz0of8kg8kgko.png"
            :background-color="serie.background_color"
            class="pt-24"
        ></episodes-section>

        <div v-if="!authenticatedUser" class="bg-blue-dark">
            <div
                class="flex flex-col md:flex-row items-center justify-between w-full max-w-screen-lg mx-auto py-6 px-6"
            >
                <app-image
                    v-if="$isMobile()"
                    :url="
                        require('../assets/animations/panchito_waving_fallback-min.png')
                    "
                    :is-local="false"
                    class="w-40"
                    :style="{ marginTop: '-65px' }"
                ></app-image>
                <SpriteAnim
                    v-else
                    class="w-40"
                    :style="{ marginTop: '-65px' }"
                    :json="
                        require('../assets/animations/panchito_waving-min.json')
                    "
                    :png="
                        require('../assets/animations/panchito_waving-min.png')
                    "
                    :fps="24"
                />

                <h3
                    class="font-primary text-2xl text-white text-center  mb-6 md:mb-0"
                >
                    {{ $config("P_TEST") }}
                </h3>

                <btn
                    class="bg-orange text-white px-6"
                    :to="registerOrHomeRoute"
                    >{{ $config("FREETRIAL") }}</btn
                >
            </div>
        </div>

        <serie-characters-slider
            :key="`serie-${serie.id}-characters-slider`"
            :characters="serie.personajes"
            background-image="https://assets.pinguinitos.com/storage/30k7idz0of8kg8kgko.png"
            background-color="#00e6dd"
            :character-custom-styles="{
                backgroundColor: serie.more.color_fondo_personaje,
                borderColor: serie.more.color_botones
            }"
        ></serie-characters-slider>

        <serie-wallpapers
            :key="`serie-${serie.id}-wallpapers-slider`"
            :wallpapers="serie.wallpapers"
            background-image="https://assets.pinguinitos.com/storage/iip7e73vfs0gcsswk.png"
            background-color="#ff6f3e"
        >
        </serie-wallpapers>

        <series-section
            :title="$config('OSERIES')"
            item-type="serie"
            :series="otherSeries"
            background-image="https://assets.pinguinitos.com/storage/iip7e73vfs0gcsswk.png"
            background-color="#752895"
        >
        </series-section>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import SerieBanner from "../components/SerieBanner";
import EpisodesSection from "../components/EpisodesSection";
import CharactersSlider from "../components/CharactersSlider";
import SerieCharactersSlider from "../components/SerieCharactersSlider";
import SerieWallpapers from "../components/SerieWallpapers";
import SeriesSection from "../components/SeriesSection";
import Btn from "../components/Btn";
import api from "../api";
import SpriteAnim from "../components/SpriteAnim";

export default {
    name: "serie",

    components: {
        SerieBanner,
        EpisodesSection,
        CharactersSlider,
        SerieCharactersSlider,
        SerieWallpapers,
        SeriesSection,
        Btn,
        SpriteAnim
    },

    data() {
        return {
            serieDataFromApi: null
        };
    },

    async created() {
        this.$store.dispatch("FETCH_SERIES");
    },

    async beforeRouteUpdate(to, from, next) {
        next();

        this.serieDataFromApi = await api.fetchSerie(to.params.id);
    },

    computed: {
        ...mapState(["authenticatedUser", "series"]),
        ...mapGetters(["registerOrHomeRoute"]),

        serie() {
            if (this.serieDataFromApi) return this.serieDataFromApi;

            return this.series.find(s => s.id == this.$route.params.id);
        },

        otherSeries() {
            return this.series.filter(s => s.id != this.serie.id);
        }
    }
};
</script>
